import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/map';

export const HOME_LABEL = 'Home';

@Component({
  selector: 'app-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.css']
})

export class BreadcrumbsComponent {
    breadcrumbs$ = this.router.events
        .filter(event => event instanceof NavigationEnd)
        .distinctUntilChanged()
        .map(event => this.buildBreadCrumb(this.activatedRoute.root));

    constructor(private activatedRoute: ActivatedRoute,
                private router: Router) {
    }


    buildBreadCrumb(route: ActivatedRoute, url: string = '',
        breadcrumbs: Array<BreadCrumb> = []): Array<BreadCrumb> {

        /* Do not add Home link to the breadcrumbs (because added by default) */
        if (route.routeConfig && route.routeConfig.data && route.routeConfig.data['breadcrumb'] === HOME_LABEL) {
            return breadcrumbs;
        }

        // If no routeConfig is avalailable we are on the root path
        const label = route.routeConfig && route.routeConfig.data ? route.routeConfig.data['breadcrumb'] : HOME_LABEL;
        const path = route.routeConfig ? route.routeConfig.path : '';

        // In the routeConfig the complete path is not available,
        // so we rebuild it each time
        // const nextUrl = `${url}${path}`;
        const nextUrl = url + (url.length > 0 ? '/' : '') + path;
        const breadcrumb = {
            label: label,
            url: nextUrl
        };
        const newBreadcrumbs = [...breadcrumbs, breadcrumb];
        if (route.firstChild) {
            // If we are not on our current path yet,
            // there will be more children to look after, to build our breadcumb
            return this.buildBreadCrumb(route.firstChild, nextUrl, newBreadcrumbs);
        }
        return newBreadcrumbs;
    }
}

export interface BreadCrumb {
    label: string;
    url: string;
}



// WEBPACK FOOTER //
// ./src/app/components/ui/breadcrumbs/breadcrumbs.component.ts